<div>
  <div [chart]="chartObject" id="{{chartId}}"></div>
</div>
